module.exports = __webpack_public_path__ + "img/EE12748028.59733efa.svg";